const ja = {
	risk: {
		riskTitle: 'ブラックリスト',
		group: 'グループ',
		store: 'Webサイト',
		omniStore: '店舗 / ウェブサイト名',
		type: '項目',
		status: 'ステータス',
		invalidText: '「無効」に設定すると、カード所有者が新しい取引を送信したときに、このルールに基づく取引は自動的にブロックされなくなります。',
		enableText: '「有効」に設定すると、ブラックリスト ルールがすぐに有効になります。',
		title_enable: '有効',
		title_invalid: '無効化',
		success: '操作は成功しました',
		notUpload: 'ファイルがまだアップロードされていないため、送信できません。',
		downloadFile: 'テンプレートをダウンロード',
		bulkUploadText: 'まずテンプレート ファイルをダウンロードし、必要に応じて入力してからアップロードしてください',
		bulkTitle: '一括アップロード',
		data: 'データ',
		country: '国 / 地域',
		state: '都道府県 / 州',
		city: '市区町村',
		adrress: '詳しい住所',
		format: 'カード番号は次の 2 つの形式をサポートしています。',
		format1: '1. 完全なカード番号 (例: 「1234567890123456」)',
		format2: '2. 最初の 6 桁、****、最後の 4 桁、例: "123456****1234"',
		applyTo: 'すべての Web サイトに適用されます',
		omniApplyTo: 'すべての店舗とウェブサイトが対象',
		applyAll: 'このオプションをオンにすると、現在構成されているブラックリスト ルールが、今後追加されるすべての Web サイトに適用されます。',
		omniApplyAll: 'このオプションをオンにすると、現在構成されているブラックリスト ルールが、今後追加されるすべての新しいストアと Web サイトに適用されます。',
		cancel: 'キャンセル',
		save: '保存',
		error: '入力してください',
		addBlockRule: '新しいブラックリストルールを追加する',
		editBlockRule: 'ルールを編集する'

	},
	button: {
		add: '新規追加',
		bulkAdd: '一括追加',
		enable: '有効',
		disable: '無効化',
		introduction: 'ブラックリスト項目の説明',
		cancel: 'キャンセル',
		confirm: '確認'
	},
	table: {
		type: '項目',
		rule: 'ルール',
		store: '対象Webサイト',
		omniStore: '対象店舗・Webサイト',
		createTime: '作成日時',
		updateTime: '更新日時',
		operator: '担当者',
		status: 'ステータス',
		action: '操作',
	  	edit: '編集',
		error: '必須項目です'

	},
	introduction: {
		title: 'ブラックリスト操作ガイド',
		tip1: 'トランザクション注文がブラックリスト ルールにヒットすると、トランザクション注文はブロックされ、トランザクションを続行できなくなります。ブラックリスト ルールを追加する場合は注意してください。',
		tip2: '現在アクセス許可を持っている Web サイトのブラックリストに対してのみ、表示、追加、変更、およびその他の操作を行うことができます。',
		omniTip2: '現在権限を持っているストアおよび Web サイトのブラックリストのみを表示、追加、および変更できます。',
		q1: '1. ブラックリストのディメンションの解釈',
		q2: '2. 上記の情報はどこで入手できますか?',
		q2Desc: 'メニュー バーを見つけて、[トランザクション管理] -> [トランザクション クエリ] -> [トランザクション シリアル番号] をクリックして、[トランザクションの詳細] ページに移動します。',
		q3: '3. Acc ID はどこで確認できますか?',
		q3Desc: 'メニューバーの「Webサイト管理」で、ブラックリストルールを設定するWebサイトを見つけて、対応するAcc IDを確認します。',
		omniQ3Desc: 'メニューバーの「ストア/Webサイト管理」で、ブラックリストルールを設定するストア/Webサイトを見つけて、対応するAcc IDを確認します。',
		card: 'カード番号',
		card_desc: '完全なカード番号、最初の 6 桁と最後の 4 桁',
		card_example: '1234567890123456、123456****1234',
		phone: '電話',
		phone_desc: '荷受人の電話番号',
		phone_example: '8617700000000',
		email: 'メールアドレス',
		email_desc: '荷受人のメールアドレス',
		email_example: 'XXX@hotmail.com',
		emailDomain: '電子メールのドメイン名',
		emailDomain_desc: '荷受人のメールドメイン名',
		emailDomain_example: 'hotmail.com',
		address: 'お届け先の住所',
		address_desc: '荷受人の住所（国、県、市、番地を含む）',
		address_example: '中国浙江省杭州市浜江区江陵路567号3階',
		type: '項目',
		desc: '意味',
		example: '例',
		comfirm: '確認する'
	}
}
export default ja
